import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { loginUser } from "../../store/actions/auth.action";
import { loginWithMicrosoft } from "../../endpoints/auth.service";
import { getPostLoginRoute } from "../../router/routerHelperFunctions";
import { EnumUserTypes } from "../../utils/constants";
import { getHiringCompanyDetails } from "../../endpoints/company.service";
import { setCompanies } from "../../store/actions/company.action";
import LoadingAnimation from "../../assets/svg/LoadingAnimation";

const MicrosoftCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code || !state) {
      enqueueSnackbar("Missing Microsoft login parameters.", {
        variant: "error",
      });
      navigate("/login", { replace: true });
      return;
    }

    const handleMicrosoftLogin = async () => {
      try {
        const { data, success } = await loginWithMicrosoft({ code, state });
        if (!success) {
          throw new Error("Microsoft login failed.");
        }

        const loginEmail = data?.user?.email;
        if (data?.user?.ssoEnabled && loginEmail) {
          localStorage.setItem("ssoEmail", loginEmail);
        } else {
          localStorage.removeItem("ssoEmail");
        }

        dispatch(loginUser(data));

        if (data?.user?.userType === EnumUserTypes.HIRING_COMPANY) {
          try {
            const { success, data } = await getHiringCompanyDetails();
            if (success) {
              dispatch(setCompanies(data));
            }
          } catch (error) {
            enqueueSnackbar(error, { variant: "error" });
          }
        }

        const target = getPostLoginRoute(data?.user);
        navigate(target, { replace: true });
      } catch (error) {
        enqueueSnackbar(error, { variant: "error" });
        navigate("/login", { replace: true });
      }
    };

    handleMicrosoftLogin();
  }, [dispatch, enqueueSnackbar, navigate]);

  return (
    <div className="h-full flex items-center justify-center">
      <div className="flex items-center gap-2 text-light-black font-medium">
        <LoadingAnimation />
        <span>Signing you in with Microsoft...</span>
      </div>
    </div>
  );
};

export default MicrosoftCallback;
